import { KlantprofielVraagOptions } from "../../../.generated/forms/formstypes";
import { CardSpec, QuestionType, TitleType } from "../../infra/klantprofiel-schema";
import { WelkeUitgavenBeperkenExtra } from "../welkeuitgavenbeperken-extra";

export const arbeidsongeschiktheidQuestionSpecs: CardSpec[] = [
  {
    sections: [
      {
        title: TitleType.custom,
        customTitle: "Kennisniveau van onderwerpen die te maken hebben met arbeidsongeschiktheid",
        subtitle: "Geef per onderwerp het kennisniveau aan door het bolletje te slepen.",
        questions: [
          {
            question: KlantprofielVraagOptions.KennisInkomenssituatieNaAo,
            type: QuestionType.slider
          },
          {
            question: KlantprofielVraagOptions.KennisAoVerzekeringen,
            type: QuestionType.slider
          },
          {
            question: KlantprofielVraagOptions.KennisAoVoorzieningWerkgever,
            type: QuestionType.slider
          },
          {
            question: KlantprofielVraagOptions.KennisAoVoorzieningWia,
            type: QuestionType.slider
          }
        ]
      }
    ]
  },
  {
    title: "Welke maatregelen wenst u te treffen voor als u of uw partner arbeidsongeschikt wordt?",
    questions: [
      {
        title: TitleType.aanvrager,
        question: KlantprofielVraagOptions.WensMaatregelenAoAanvrager1,
        type: QuestionType.checkbox
      },
      {
        title: TitleType.aanvrager,
        question: KlantprofielVraagOptions.WensMaatregelenAoAanvrager2,
        type: QuestionType.checkbox
      },
      {
        question: KlantprofielVraagOptions.WaarvoorInkomensaanvullingAo,
        type: QuestionType.checkbox,
        condition: [
          {
            question: KlantprofielVraagOptions.WensMaatregelenAoAanvrager1,
            answer: 140501
          },
          {
            question: KlantprofielVraagOptions.WensMaatregelenAoAanvrager2,
            answer: 140601
          }
        ]
      },
      {
        question: KlantprofielVraagOptions.HoelangInkomensaanvullingAo,
        type: QuestionType.radioMetJaar,
        condition: [
          {
            question: KlantprofielVraagOptions.WensMaatregelenAoAanvrager1,
            answer: 140501
          },
          {
            question: KlantprofielVraagOptions.WensMaatregelenAoAanvrager2,
            answer: 140601
          }
        ]
      }
    ]
  },
  {
    questions: [
      {
        question: KlantprofielVraagOptions.MaatregelenFinancieleGevolgenAo,
        type: QuestionType.radio
      },
      {
        question: KlantprofielVraagOptions.UitgavenBeperkenAo,
        type: QuestionType.radio,
        condition: [
          {
            question: KlantprofielVraagOptions.MaatregelenFinancieleGevolgenAo,
            answer: 140903
          }
        ]
      },
      {
        question: KlantprofielVraagOptions.WelkeUitgavenBeperkenAo,
        type: QuestionType.toggleCheckbox,
        extra: WelkeUitgavenBeperkenExtra,
        condition: [
          {
            question: KlantprofielVraagOptions.UitgavenBeperkenAo,
            answer: 141001
          }
        ]
      }
    ]
  }
];
